module.exports = __webpack_public_path__ + "img/browse files.3ba140f4.svg";